<template>
    <div
        v-for="(enrollment, index) in enrollmentInput"
        :key="enrollment.enrollmentType.id"
    >
        <enrollment-type-quantity-picker
            :enrollment="enrollment"
            @update-enrollment-count="(count: number) => updateEnrollmentCount(index, count)"
        />
    </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import EnrollmentTypeQuantityPicker from '~/components/PurchaseContract/EnrollmentTypeQuantityPicker.vue'

const props = defineProps<{
    enrollmentInput: {
        enrollmentType: {
            id: string
            singular: string
            plural: string
        }
        count: number
        minQuantity: number
        maxQuantity: number
    }[]
}>()

const emit = defineEmits<{
    (
        e: 'update:enrollment-input',
        payload: {
            enrollmentType: {
                id: string
                singular: string
            }
            count: number
            minQuantity: number
            maxQuantity: number
        }[]
    ): void
}>()

onMounted(() => {
    // if only one enrollment type
    if (props.enrollmentInput?.length === 1) {
        // if that enrollment count is at 0
        if (props.enrollmentInput[0].count < 1) {
            // auto select to have one
            updateEnrollmentCount(0, 1)
        }
    }
})

function updateEnrollmentCount(index: number, count: number) {
    emit('update:enrollment-input', [
        ...props.enrollmentInput.slice(0, index),
        {
            ...props.enrollmentInput[index],
            count
        },
        ...props.enrollmentInput.slice(index + 1)
    ])
}
</script>
